/**
 * @file
 * Adapted -- Simple Accessible Accordion.
 * @see https://codepen.io/svinkle/pen/mKfru
 *
 * @TODO: use atoms/accordion.
 * @TODO: Cannot decouple and put in /js since other templates and code are
 * using the accordion classes.
 */

(function accordionWidgetScript($, once) {
  'use strict';

  // Vars.
  const showOneAnswerAtATime = false;

  /**
   * Save question focus.
   */
  function saveFocus(question, thisSectionQuestions) {
    // Reset other tab attributes.
    thisSectionQuestions
      .not(question)
      .attr('tabindex', '-1')
      .attr('aria-selected', 'false');

    // Set this tab attributes.
    question.attr({
      tabindex: '0',
      'aria-selected': 'true',
    });
  }

  /**
   * Show answer on click.
   */
  function showAnswer(question, thisSectionQuestions, thisSectionAnswers) {
    const thisAnswer = question.next();
    // Save focus.
    saveFocus(question, thisSectionQuestions);

    // Set this tab attributes.
    if (thisAnswer.hasClass('accordion-widget__answer--active')) {
      // Hide answer.
      thisAnswer.removeClass('accordion-widget__answer--active');
      question.attr('aria-expanded', 'false');
      thisAnswer.attr('aria-hidden', 'true');
      thisAnswer.prev(thisSectionQuestions).removeClass('accordion-widget__question--active');
    } else {
      if (showOneAnswerAtATime) {
        // Hide all answers.
        thisSectionAnswers.removeClass('accordion-widget__answer--active').attr('aria-hidden', 'true');
        thisSectionQuestions.removeClass('accordion-widget__question--active').attr('aria-expanded', 'false');
      }

      // Show answer.
      thisAnswer.addClass('accordion-widget__answer--active');
      question.attr('aria-expanded', 'true');
      thisAnswer.attr('aria-hidden', 'false');
      thisAnswer.prev(thisSectionQuestions).addClass('accordion-widget__question--active');
    }
    const $allActiveQuestions = question.closest('.js-accordion-section').find(thisSectionQuestions).filter('.accordion-widget__question--active');
    if ($allActiveQuestions.length === thisSectionQuestions.length) {
      question.closest('.js-accordion-section').find('.accordion-widget__toggle-all').addClass('collapse');
    } else {
      question.closest('.js-accordion-section').find('.accordion-widget__toggle-all').removeClass('collapse');
    }
  }

  /**
   * Keyboard interaction.
   */
  function keyboardInteraction(question, e, thisSectionQuestions, thisSectionAnswers) {
    const item = question.parent();
    const itemSiblings = item.siblings();
    const nextItem = item.next();
    const prevItem = item.prev();
    const nextQuestion = nextItem.children('.js-accordion-question');
    const previousQuestion = prevItem.children('.js-accordion-question');
    const firstQuestion = itemSiblings.first().children('.js-accordion-question');
    const lastQuestion = itemSiblings.last().children('.js-accordion-question');

    switch (e.key) {
      // Left/Up.
      case 'ArrowLeft':
      case 'ArrowUp':
        e.preventDefault();
        e.stopPropagation();

        // Check for previous question.
        if (previousQuestion.length > 0) {
          // No previous, set focus on last question.
          lastQuestion.focus();
        } else {
          // Move focus to previous question.
          previousQuestion.focus();
        }
        break;

      // Right/Down.
      case 'ArrowRight':
      case 'ArrowDown':
        e.preventDefault();
        e.stopPropagation();

        // Check for next question.
        if (nextQuestion.length > 0) {
          // No next, set focus on first question.
          firstQuestion.focus();
        } else {
          // Move focus to next question.
          nextQuestion.focus();
        }
        break;

      // Home.
      case 'Home':
        e.preventDefault();
        e.stopPropagation();

        // Set focus on first question.
        firstQuestion.focus();
        break;

      // End.
      case 'End':
        e.preventDefault();
        e.stopPropagation();

        // Set focus on last question.
        lastQuestion.focus();
        break;

      // Enter/Space
      case 'Enter':
      case ' ':
        e.preventDefault();
        e.stopPropagation();

        // Show answer content.
        showAnswer(question, thisSectionQuestions, thisSectionAnswers);
        break;

      default:
        break;
    }
  }

  function toggleAllButtonClickKeydownListener(event) {
    if (event.type === 'keydown' && event.key !== 'Enter') {
      return;
    }

    event.preventDefault();
    const thisToggleAllButton = event.currentTarget;
    const $section = $(thisToggleAllButton).closest('.js-accordion-section');
    const $toggleAlls = $section.find('.accordion-widget__toggle-all');
    const $questions = $section.find('.js-accordion-question');
    const $answers = $section.find('.js-accordion-answer');

    const $allActiveQuestions = $questions.filter('.accordion-widget__question--active');
    if ($allActiveQuestions.length === 0) {
      // All closed originally: Expand all.
      $questions
        .addClass('accordion-widget__question--active')
        .attr('aria-expanded', 'true');
      $answers
        .addClass('accordion-widget__answer--active')
        .attr('aria-hidden', 'false');
      $toggleAlls.addClass('collapse');
    } else if ($allActiveQuestions.length === $questions.length) {
      // All opened originally: Collapse all.
      $questions
        .removeClass('accordion-widget__question--active')
        .attr('aria-expanded', 'false');
      $answers
        .removeClass('accordion-widget__answer--active')
        .attr('aria-hidden', 'true');
      $toggleAlls.removeClass('collapse');
      if (thisToggleAllButton.classList.contains('accordion-button--bottom')) {
        Drupal.ahsThemeSite.scrollTop(
          $toggleAlls.find('.accordion-button--top'),
          {
            focusElement: thisToggleAllButton,
          },
        );
      }
    } else {
      // Some open, some closed: Expand all.
      $questions
        .addClass('accordion-widget__question--active')
        .attr('aria-expanded', 'true');
      $answers
        .addClass('accordion-widget__answer--active')
        .attr('aria-hidden', 'false');
      $toggleAlls.addClass('collapse');
    }
  }

  function accordionQuestionOnClick(event) {
    event.preventDefault();
    const question = event.currentTarget;
    const $question = $(question);
    const $section = $question.closest('.js-accordion-section');
    const $questions = $section.find('.js-accordion-question');
    const $answers = $section.find('.js-accordion-answer');

    showAnswer($question, $questions, $answers);
  }

  function accordionQuestionOnKeydown(event) {
    const question = event.currentTarget;
    const $question = $(question);
    const $section = $question.closest('.js-accordion-section');
    const $questions = $section.find('.js-accordion-question');
    const $answers = $section.find('.js-accordion-answer');

    keyboardInteraction($question, event, $questions, $answers);
  }

  function accordionQuestionOnFocus(event) {
    const question = event.currentTarget;
    const $question = $(question);
    const $section = $question.closest('.js-accordion-section');
    const $questions = $section.find('.js-accordion-question');
    const $answers = $section.find('.js-accordion-answer');

    saveFocus($question, $questions, $answers);
  }

  function initWidget(widget) {
    const $section = $(widget);

    // Expand / Collapse all
    $section
      .find('.accordion-widget__toggle-all')
      .find('.accordion-button')
      .on('click keydown', toggleAllButtonClickKeydownListener);

    // Items.
    $section.find('.js-accordion-question').get().forEach((question, i) => {
      const $question = $(question);

      // Make first tab clickable.
      if (i === 0) {
        $question.attr('tabindex', '0');
      }

      // Click event.
      $question.on('click', accordionQuestionOnClick);

      // Keydown event.
      $question.on('keydown', accordionQuestionOnKeydown);

      // Focus event.
      $question.on('focus', accordionQuestionOnFocus);
    });
  }

  Drupal.behaviors.themeAccordionWidget = {
    attach(context) {
      const widgets = once('themeAccordionWidget', '.js-accordion-section', context);
      if (widgets.length === 0) {
        return;
      }

      widgets.forEach((widget) => {
        initWidget(widget);
      });
    },
  };
}(jQuery, once));
